import { SpeedDial, useTheme } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';

interface HomeChatSpeedDialProps {
  onClick: () => void;
}

const HomeChatSpeedDial = ({ onClick }: HomeChatSpeedDialProps) => {
  const theme = useTheme();

  return (
    <SpeedDial
      ariaLabel="Chat with AI"
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: theme.zIndex.speedDial,
      }}
      icon={<ChatIcon />}
      onClick={onClick}
    />
  );
};

export default HomeChatSpeedDial;